module.exports = __webpack_public_path__ + "img/pin-stroke.6ad77337.svg";